// 保存の実行制御(採番確定・確認ダイアログ・送信)をまとめる。
// 本文は HinbanMaster.js から移設したもの。

export function createSaveOrchestrator(deps) {
    const {
        DicVal,
        G_id,
        Getrowid,
        GridData,
        HINBAN_NUMBERING_FAILED_MESSAGE,
        HINBAN_WASH_PANEL_TYPE,
        LoadData,
        SetPLData,
        buildHinbanWashSaveRows,
        buildMainSaveData,
        buildMainSaveDetail,
        buildPendingKakousijiSaveEntries,
        buildSaveColumnInfo,
        cfFileUpload,
        cfNewUploadFile,
        changestatus,
        columninfo,
        confirmPdtcSkuNameSyncOnSave,
        dispatch,
        edittingcode,
        ensureBrandHinbanValuesOnSave,
        ensureOppiHinbanAssigned,
        ensureSubBrandValuesOnSave,
        entrydataRef,
        fileRef,
        fnc,
        formid,
        formstatus,
        gridlist,
        hasResolvedOppiCode,
        imageRef,
        isEmpty,
        isEnabled,
        mergeKakousijiSaveEntries,
        normalizeKakousijiSampleDetailForStoreByType,
        prepareSsdqRowsForSaveEntries,
        primarykey,
        setedittingcode,
        storeRowData
    } = deps;

    function Save(finallycallback, nocheck, skipPdtcSkuNameConfirm) {
        const showNumberingFailedMessage = function () {
            fnc.current.wait(false);
            fnc.current.warnmsg(HINBAN_NUMBERING_FAILED_MESSAGE);
        };
        const currentEntryData = DicVal(entrydataRef, "current", null);
        if (!hasResolvedOppiCode(currentEntryData)) {
            ensureOppiHinbanAssigned({
                showSuccessMessage: false,
                onSuccess: function () {
                    Save(finallycallback, nocheck, skipPdtcSkuNameConfirm);
                },
                onError: showNumberingFailedMessage
            });
            return;
        }
        ensureBrandHinbanValuesOnSave(
            () => ensureSubBrandValuesOnSave(() => confirmPdtcSkuNameSyncOnSave(() => continueSave(finallycallback, nocheck), skipPdtcSkuNameConfirm)),
            showNumberingFailedMessage
        );
    }
    function buildCurrentHinbanSavePayload(nocheck) {
        var newfiles = (formstatus === "ENTRY FORM" ? [] : cfNewUploadFile(imageRef, fileRef));
        if (newfiles.length > 10) {
            fnc.current.warnmsg("新規登録できるアップロードファイル数は10までです。");
            return null;
        }

        storeRowData();
        SetPLData();

        var detail = {};
        for (let i = 0; i < gridlist.length; i++) {
            if (gridlist[i].id === G_id.PL) continue;
            const panelRows = GridData(gridlist[i]);
            const detailType = String(DicVal(gridlist[i], 'type', '')).trim();
            detail[gridlist[i].type] = detailType === HINBAN_WASH_PANEL_TYPE
                ? buildHinbanWashSaveRows(panelRows)
                : normalizeKakousijiSampleDetailForStoreByType(detailType, panelRows);
        }

        const saveColumnInfo = buildSaveColumnInfo(columninfo);
        const mainSaveData = buildMainSaveData();
        const pendingKakousijiEntries = buildPendingKakousijiSaveEntries();
        const mergedKakousijiEntries = mergeKakousijiSaveEntries(DicVal(mainSaveData, "kakousijiEntries", []), pendingKakousijiEntries);
        const ssdqPrepareResult = prepareSsdqRowsForSaveEntries(mergedKakousijiEntries);
        if (!DicVal(ssdqPrepareResult, 'status', false)) {
            fnc.current.warnmsg(DicVal(ssdqPrepareResult, 'message', ''));
            return null;
        }
        const paramdata = {
            controller: formid,
            data: mainSaveData,
            detail: buildMainSaveDetail(detail),
            images: imageRef.current,
            files: fileRef.current,
            colinfo: saveColumnInfo,
            code: edittingcode,
            noconfirm: nocheck,
            kakousijiEntries: mergedKakousijiEntries
        };

        return { paramdata, newfiles };
    }
    function continueSave(finallycallback, nocheck) {
        const savePayload = buildCurrentHinbanSavePayload(nocheck);
        if (isEmpty(savePayload)) return;
        const { paramdata, newfiles } = savePayload;

        fnc.current.postaxios(formstatus === "ENTRY FORM" ? "hinbanmaster/UpdateHinbanEntry" : "hinbanmaster/InsertHinbanEntry", paramdata,
            {
                onSuccess: function (data) {
                    if (data.warning.length === 0) {
                        fnc.current.modify(false);
                        let code = data.request;

                        if (formstatus !== "ENTRY FORM") {
                            let pkey = primarykey();
                            if (pkey !== "") entrydataRef.current[pkey] = data.request;
                            setedittingcode(data.request);
                            dispatch(changestatus("ENTRY FORM"));
                        }

                        if (newfiles.length !== 0) {
                            cfFileUpload("hinbanmaster", code, newfiles, fnc, () => LoadData(code));
                        } else {
                            fnc.current.success();
                            if (formstatus === "ENTRY FORM") {
                                data.data["rowid"] = Getrowid();
                                finallycallback(data.data);
                            }
                            LoadData(code);
                        }
                        fnc.current.wait(false);
                        return;
                    }

                    if (isEnabled(data.confirm)) {
                        var msgs = [];
                        for (let i = 0; i < data.warning.length; i++) {
                            msgs.push("・" + data.warning[i].message);
                        }
                        fnc.current.confmsg(msgs, () => Save(finallycallback, true, true));
                    } else {
                        let msg = data.warning.length + "件の制約違反により登録できませんでした。";
                        fnc.current.showwarndescription(msg, data.warning);
                    }
                    fnc.current.wait(false);
                },
                onError: function (data) {
                    fnc.current.wait(false);
                    let msg = "処理に失敗しました";
                    if (!isEmpty(data.errDescription)) {
                        msg = data.errDescription;
                    }
                    fnc.current.warnmsg(msg);
                }
            }
        )
    }

    return {
        Save,
        buildCurrentHinbanSavePayload,
        continueSave
    };
}
